import { HouseholdType, QTask, QTaskTag } from '@qwealth/qdata';

import { DateRange } from './DateRange';
import { SortDirection } from './SortDirection';

export const WORKFLOW_OVERDUE = 'Overdue';
export const WORKFLOW_COMPLETED = 'Completed';
export const WORKFLOW_NOT_STARTED = 'Not Started';
export const WORKFLOW_IN_PROGRESS = 'In Progress';
export const WORKFLOW_STATUS_LIST = [WORKFLOW_NOT_STARTED, WORKFLOW_IN_PROGRESS, WORKFLOW_COMPLETED] as const;
export type WorkflowStatus = (typeof WORKFLOW_STATUS_LIST)[number];

export interface AvailableWorkflowTemplate {
  workflowTemplateId: number;
  workflowTemplateName: string;
  isAssignable: boolean;
}

export interface AssignedWorkflowGroup {
  tasksGroup: QTask[];
}

export interface AssignedWorkflow {
  id: number;
  name: string;
  description: string;
  partnerId: number;
  iaCode: string | null;
  dueDate: string | null;
  status: WorkflowStatus;
  householdQid: string;
  householdName: string;
  householdType: HouseholdType;
  tags: QTaskTag[];
  groups: AssignedWorkflowGroup[];
  isFromGlobalTemplate: boolean;
}

export interface AssignWorkflowTemplatePayload {
  householdQid: string;
  workflowTemplateIds: number[];
}

export type AssignedWorkflowsFilters = {
  filterDateRange: DateRange;
  filterDateValue: string;
  filterStatus: Array<WorkflowStatus>;
  filterTags: Array<string>;
  filterPartnerId?: number;
  filterIaCode?: string | null;
  sortDirection: SortDirection;
  filterQuery?: string;
};

export type AssignedWorkflowsQueryParams = {
  'dueDate[dateafter]'?: string;
  'dueDate[datebefore]'?: string;
  'dueDate[orderby]'?: 'DESC' | 'ASC';
  status?: string;
  tags?: string;
  limit?: number;
  partnerId?: number;
  iaCode?: string;
  householdQid?: string;
};

export type WorkflowsActions = {
  viewAssignedWorkflow?: (assignedWorkflow: AssignedWorkflow) => void;
  assignWorkflowTemplate?: () => void;
  deleteAssignedWorkflow?: () => void;
  onAssignedWorkflowTaskUpdate?: (task: QTask) => void;
  onWorkflowDashboardFiltersChange?: () => void;
};
